import {Component, Input} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';

@Component({
	selector: 'form-radio',
	templateUrl: './radio.component.html',
	styleUrls: ['./radio.component.scss']
})
export class RadioComponent {

	@Input()
	control: UntypedFormControl;

	@Input()
	id: string = this.dynamicIdService.getId('radio');

	@Input()
	label: string;

	@Input()
	value: string;

	@Input()
	markAsWarning: boolean;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	@Input()
	name: string;

	ControlTemplate = ControlTemplate;

	constructor(private dynamicIdService: DynamicIdService) {
	}
}
